module.exports = __webpack_public_path__ + "img/calendar-circle.2e7d3937.svg";